var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-2" }, [
    _c("table", { staticClass: "table table-bordered" }, [
      _c("thead", { staticClass: "thead-light" }, [
        _c("tr", { staticClass: "bg-primary" }, [
          _c("th", [_vm._v("\n                    #\n                ")]),
          _vm._v(" "),
          _c("th", [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__("globals.name")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c("th", [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__("globals.slug")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "w-25" }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.types, function (type, index) {
          return _c("transition", { key: index, attrs: { name: "row" } }, [
            _c("tr", [
              _c("td", [
                _vm._v(
                  "\n                        " +
                    _vm._s(index + 1) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "w-25" }, [
                _c(
                  "p",
                  { staticClass: " ", attrs: { id: "title-field" + type.id } },
                  [_vm._v(_vm._s(type.title))]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control hidden",
                  attrs: { type: "text", id: "title-input-box" + type.id },
                  domProps: { value: type.title },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n                        " +
                    _vm._s(type.slug) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center w-25" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-info",
                    attrs: { id: "edit-button" + type.id },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.editType(type.id, index)
                      },
                    },
                  },
                  [_vm._v("Edit")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-danger",
                    attrs: { id: "delete-button" + type.id },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.destroyType(type.slug, index)
                      },
                    },
                  },
                  [_vm._v("Delete")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-success hidden",
                    attrs: { id: "save-button" + type.id },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.saveType(type.id, index)
                      },
                    },
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-warning hidden",
                    attrs: { id: "cancel-button" + type.id },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.cancelEdit(type.id, index)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
              ]),
            ]),
          ])
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.create_form = !_vm.create_form
              },
            },
          },
          [
            _vm.create_form === false
              ? _c("i", { staticClass: "feather icon-plus" })
              : _vm._e(),
            _vm._v(" "),
            _vm.create_form === true
              ? _c("i", { staticClass: "feather icon-minus" })
              : _vm._e(),
            _vm._v("\n            Create New Type\n        "),
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.create_form
            ? _c("div", { staticClass: "mt-2 card p-1 w-50" }, [
                _c("form", [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "tag_name" } }, [
                      _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v(_vm._s(_vm.type)),
                      ]),
                      _vm._v(" Type Name"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.type_name,
                            expression: "type_name",
                          },
                        ],
                        staticClass: "form-control mr-1",
                        attrs: { id: "tag_name", type: "text" },
                        domProps: { value: _vm.type_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.type_name = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.createType()
                            },
                          },
                        },
                        [_vm._v("Create")]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.error_create
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-left text-danger help-block font-small-1",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("i", { staticClass: "feather icon-x-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.error_create) +
                                "\n                        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }